import React, { useState, useEffect, useContext } from 'react';
import DataContext from '../data/DataContext';
import { withStyles, Drawer } from '@material-ui/core';
import { Divider } from '@material-ui/core';
import ArrowDown from '../../asset/img/icon_arrow_down.svg';
import Close from '../../asset/img/icon_close.svg';

const styles = (theme) => ({
  root: {
    position: 'relative',
    maxWidth: '100%',
    width: '100%',
  },
  drawerFrame: {
    // borderRadius:"10px 10px 0px 0px",
    borderRadius: 'var(--borderRadius)',
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    height: 'var(--height)',
    overflowY: 'auto',
  },
  drawerRoot: {
    // padding: "10px 2px",
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
  titleClose: {
    fontFamily: 'inherit',
    fontSize: theme.font.size18,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    padding: '1px 0px',
  },
  titleCloseTop: {
    fontFamily: 'inherit',
    fontSize: theme.font.size18,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    width: '100%',
    padding: '1px 0px',
  },
  titleArrow: {
    display: 'flex',
    margin: '20px 0 19.5px 16px',
    fontFamily: 'inherit',
    fontSize: '18px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
  },
  divider: {
    height: '1px',
    background: '#000',
    margin: '0px 14px 19.5px 14px',
  },
  closeArrow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '16px',
      height: '16px',
      cursor: 'pointer',
    },
  },
  close: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '24px',
      height: '24px',
      cursor: 'pointer',
    },
  },
  closeTop: {
    display: 'flex',
    width: '100%',
    justifyContent: 'end',
    '& img': {
      width: '24px',
      height: '24px',
      cursor: 'pointer',
    },
    border: 'none',
    background: 'none',
  },
  drawerHeaderClose: {
    display: 'flex',
    minHeight: 'auto', //"46px",
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 16px',
  },
  drawerHeaderCloseTop: {
    display: 'flex',
    minHeight: 'auto:', //"46px",
    justifyContent: 'space-between',
    alignItems: 'center',
    // padding: "10px 9px 10px 14px",
    padding: '16px 16px 6px 16px',
    flexDirection: 'column',
  },
  componentWrapper: {
    overflowY: 'auto',
  },
  btnClose: {
    border: 'none',
    background: 'none',
  },
});

function Modal({ component: Component, ...props }) {
  const {
    classes,
    children,
    data,
    parentFunc,
    parentVal,
    anchor = 'bottom',
    modalOpen,
    modalClose,
    title,
    titleDivider = true,
    titleClassName,
    height = '70%',
    borderRadius = '10px',
    closeType = 'close',
    customClose,
  } = props;

  const [childComponent, setChildComponent] = useState(null);
  const context = useContext(DataContext);

  useEffect(() => {
    if (Component) {
      setChildComponent(
        <Component
          data={data}
          parentFunc={parentFunc}
          modalClose={modalClose}
          parentVal={parentVal}
          customClose={customClose}
        />
      );
    } else {
      setChildComponent(children);
    }
    // console.log("childComponent", Component, data, parentFunc)
  }, [Component]);

  return (
    <div className={classes.root}>
      <Drawer
        anchor={anchor}
        open={modalOpen}
        onClose={customClose || modalClose}
        classes={{ paper: classes.drawerFrame }}
        style={{ '--height': height, '--borderRadius': borderRadius }}
      >
        <div className={classes.drawerRoot}>
          {closeType === 'close' ? (
            <div className={classes.drawerHeaderClose}>
              {title && (
                <div className={[classes.titleClose, titleClassName].join(' ')}>
                  {' '}
                  {title}{' '}
                </div>
              )}
              <div className={classes.close}>
                <button className={classes.btnClose} onClick={customClose || modalClose}>
                  <img src={Close} className={classes.arrowDown} alt="닫기" />
                </button>
              </div>
            </div>
          ) : closeType === 'close-top' ? (
            <div className={classes.drawerHeaderCloseTop}>
              <button className={classes.closeTop} onClick={customClose || modalClose}>
                <img src={Close} className={classes.arrowDown} alt="닫기" />
              </button>
              {title && <div className={classes.titleCloseTop}> {title} </div>}
            </div>
          ) : (
            <div className={classes.drawerHeader}>
              <div className={classes.closeArrow}>
                <img
                  src={ArrowDown}
                  className={classes.arrowDown}
                  onClick={customClose || modalClose}
                />
              </div>
              <div className={classes.titleArrow}> {title} </div>
            </div>
          )}
          {title && titleDivider && <Divider classes={{ root: classes.divider }} />}
          <div className={classes.componentWrapper}>{childComponent}</div>
        </div>
      </Drawer>
    </div>
  );
}
export default withStyles(styles)(Modal);
